import { Component, ElementRef, ViewChild } from '@angular/core';
import { UserService } from '../../../../../admin/src/app/services/user.service';

@Component({
  selector: 'app-bulk-campaign-update-modal',
  templateUrl: './bulk-campaign-update-modal.component.html',
  styleUrls: ['./bulk-campaign-update-modal.component.scss'],
})
export class BulkCampaignUpdateModalComponent {
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;

  activeFilterTab: 'all' | 'errors' | 'valid' = 'all';
  isDragging = false;

  constructor(public userService: UserService) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.userService.stageCsvFile(file);
      input.value = ''; // Reset input to allow re-uploading the same file if needed
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onFileDropped(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      this.userService.stageCsvFile(file);
    }
  }

  triggerFileInput(): void {
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.click();
    }
  }

  removeStagedFile(): void {
    this.userService.removeStagedFile();
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = '';
    }
  }

  onValidate(): void {
    this.userService.validateUploadedCsv();
  }

  setFilterTab(tab: 'all' | 'errors' | 'valid'): void {
    this.activeFilterTab = tab;
  }

  getFilteredRows() {
    const rows = this.userService.bulkCampaignUpdateModal.rows;
    if (this.activeFilterTab === 'errors') {
      return rows.filter((r) => r.status === 'error');
    }
    if (this.activeFilterTab === 'valid') {
      return rows.filter((r) => r.status === 'valid');
    }
    return rows;
  }

  onSkipToggle(checked: boolean): void {
    this.userService.bulkCampaignUpdateModal.skipErrors = checked;
  }

  downloadSample(): void {
    this.userService.downloadSampleCsv();
  }

  exportErrors(): void {
    this.userService.exportErrorsCsv();
  }

  goToStep1(): void {
    this.userService.bulkCampaignUpdateModal.step = 1;
    this.userService.bulkCampaignUpdateModal.file = null;
    this.userService.bulkCampaignUpdateModal.rows = [];
    this.userService.bulkCampaignUpdateModal.errorCount = 0;
    this.userService.bulkCampaignUpdateModal.validCount = 0;
    this.userService.bulkCampaignUpdateModal.totalRows = 0;
    this.activeFilterTab = 'all';
  }

  applyUpdates(): void {
    this.userService.executeBulkCampaignUpdate();
  }

  closeModal(): void {
    this.userService.closeBulkCampaignUpdateModal();
    this.activeFilterTab = 'all';
  }
}

